import React, { useEffect, useState } from 'react';
import { FiUser, FiClipboard, FiExternalLink, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { adminAPI } from '../../../services/api';

const HomeworkCheckingPage = () => {
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState({ studentId: '', status: '' });
    const [students, setStudents] = useState([]);

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter.studentId, filter.status]);

    const loadData = async () => {
        try {
            setLoading(true);
            const [subsRes, studentsRes] = await Promise.all([
                adminAPI.getHomeworkCheckingSubmissions({
                    studentId: filter.studentId || undefined,
                    status: filter.status || undefined
                }),
                adminAPI.getStudents()
            ]);
            setSubmissions(subsRes.data.submissions || []);
            setStudents(studentsRes.data.students || []);
        } catch (e) {
            console.error('Ошибка загрузки ДЗ:', e);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        const styles = {
            submitted: { bg: '#e6f7ff', color: '#1890ff', text: 'На проверке', icon: <FiAlertCircle /> },
            reviewed: { bg: '#f6ffed', color: '#52c41a', text: 'Проверено', icon: <FiCheckCircle /> },
            checked: { bg: '#f6ffed', color: '#52c41a', text: 'Проверено', icon: <FiCheckCircle /> },
            pending: { bg: '#fff7e6', color: '#fa8c16', text: 'Черновик', icon: <FiClipboard /> },
            needs_revision: { bg: '#fff7e6', color: '#fa8c16', text: 'Нужна доработка', icon: <FiClipboard /> }
        };
        const s = styles[status] || styles.submitted;
        return (
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 12px',
                background: s.bg,
                color: s.color,
                borderRadius: 12,
                fontSize: 12,
                fontWeight: 600
            }}>
                {s.icon} {s.text}
            </span>
        );
    };

    if (loading) {
        return <div style={{ padding: 20, textAlign: 'center' }}>Загрузка...</div>;
    }

    return (
        <div style={{ maxWidth: 1200, margin: '-20px auto 0', padding: '0 20px 20px' }}>
            <h1 style={{ margin: '0 0 18px 0' }}>Проверка ДЗ</h1>

            <div className="card" style={{ marginBottom: 20, padding: 20 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 15 }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                        <label>Студент</label>
                        <select
                            value={filter.studentId}
                            onChange={(e) => setFilter(prev => ({ ...prev, studentId: e.target.value }))}
                        >
                            <option value="">Все студенты</option>
                            {students.map(student => (
                                <option key={student.id} value={student.id}>
                                    {student.first_name} {student.last_name} ({student.username})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group" style={{ marginBottom: 0 }}>
                        <label>Статус</label>
                        <select
                            value={filter.status}
                            onChange={(e) => setFilter(prev => ({ ...prev, status: e.target.value }))}
                        >
                            <option value="">Все</option>
                            <option value="submitted">На проверке</option>
                            <option value="reviewed">Проверено</option>
                            <option value="pending">Черновики</option>
                        </select>
                    </div>
                </div>
            </div>

            {submissions.length === 0 ? (
                <div className="card" style={{ padding: 60, textAlign: 'center' }}>
                    <p style={{ fontSize: 18, color: '#999' }}>Нет ДЗ с выбранными фильтрами</p>
                </div>
            ) : (
                <div style={{ display: 'grid', gap: 15 }}>
                    {submissions.map((s) => (
                        <div
                            key={s.id}
                            className="card"
                            style={{ padding: 18, display: 'flex', justifyContent: 'space-between', gap: 15 }}
                        >
                            <div style={{ flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                                    <FiUser color="#4a90e2" />
                                    <strong>{s.first_name || ''} {s.last_name || ''}</strong>
                                    <span style={{ color: '#666' }}>{s.username ? `(${s.username})` : ''}</span>
                                    {getStatusBadge(s.status)}
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#666' }}>
                                    <FiClipboard />
                                    <span>{s.homework_title || 'ДЗ'}</span>
                                </div>

                                <div style={{ marginTop: 8, fontSize: 13, color: '#999' }}>
                                    {s.submitted_at ? `Отправлено: ${new Date(s.submitted_at).toLocaleString('ru-RU')}` : `Обновлено: ${new Date(s.updated_at).toLocaleString('ru-RU')}`}
                                </div>

                                {s.teacher_comment && (
                                    <div style={{ marginTop: 10, fontSize: 14, color: '#555' }}>
                                        Комментарий: {s.teacher_comment}
                                    </div>
                                )}
                            </div>

                            <button
                                onClick={() => window.open(`/admin/checking/homework/${s.id}`, '_blank')}
                                className="btn-view-submission"
                                title="Проверить"
                                style={{
                                    alignSelf: 'flex-start',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '10px 14px',
                                    minWidth: 120,
                                    justifyContent: 'center',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <FiExternalLink />
                                Проверить
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HomeworkCheckingPage;

